import { useState } from "react";
import { Mail } from "lucide-react";
import { IMAGES } from "../../lib/site-content";

const PAIRS = [
  { id: 1, label: "Calacatta Floor — Hone & Polish Restoration", before: IMAGES.ba1Before, after: IMAGES.ba1After },
  { id: 2, label: "Nero Marquina Hallway — Mirror Polish", before: IMAGES.ba2Before, after: IMAGES.ba2After },
  { id: 3, label: "Port Laurent — Full Polish Restoration", before: IMAGES.ba3Before, after: IMAGES.ba3After },
  { id: 4, label: "Concrete Floor — Diamond Polish", before: IMAGES.ba4Before, after: IMAGES.ba4After },
];

function Card({ pair }) {
  const [pos, setPos] = useState(50);
  return (
    <figure className="relative w-full aspect-[4/5] sm:aspect-[3/4] overflow-hidden bg-stone-100 group">
      <img
        src={pair.before}
        alt={`${pair.label} — before`}
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div
        className="absolute inset-0 overflow-hidden"
        style={{ width: `${pos}%` }}
      >
        <img
          src={pair.after}
          alt={`${pair.label} — after`}
          className="absolute inset-0 h-full object-cover"
          style={{ width: `${100 / (pos / 100)}%`, maxWidth: "none" }}
          loading="lazy"
        />
      </div>

      <div
        className="absolute top-0 bottom-0 w-px bg-white/90 shadow-[0_0_12px_rgba(0,0,0,0.4)]"
        style={{ left: `${pos}%` }}
      >
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-9 h-9 rounded-full bg-white border border-stone-300 flex items-center justify-center text-stone-700 text-xs font-medium select-none">
          ⇆
        </div>
      </div>

      <input
        type="range"
        min={0}
        max={100}
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
        aria-label={`Before/after slider for ${pair.label}`}
      />

      <div className="absolute top-3 left-3 px-2.5 py-1 text-[10px] tracking-[0.2em] uppercase bg-white/85 text-stone-900 pointer-events-none">
        Before
      </div>
      <div className="absolute top-3 right-3 px-2.5 py-1 text-[10px] tracking-[0.2em] uppercase bg-stone-900 text-white pointer-events-none">
        After
      </div>
      <figcaption className="absolute bottom-0 inset-x-0 p-4 bg-gradient-to-t from-black/55 to-transparent text-white text-sm pointer-events-none">
        {pair.label}
      </figcaption>
    </figure>
  );
}

export default function BeforeAfter() {
  return (
    <section id="before-after" className="relative py-16 md:py-20 bg-[#e8e2d8]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="reveal max-w-3xl mb-10">
          <p className="text-[11px] tracking-[0.3em] uppercase text-stone-500 mb-4">
            The Difference
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl tracking-tight text-stone-900">
            Before &amp; After.
          </h2>
          <p className="mt-5 text-base md:text-lg text-stone-600 leading-relaxed">
            Drag the arrow towards <span className="font-semibold text-stone-800">Before</span> to see the damaged or dull stone in its original state. To see the refinished surface, drag the arrow towards <span className="font-semibold text-stone-800">After</span>.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {PAIRS.map((p) => (
            <div key={p.id} className="reveal">
              <Card pair={p} />
            </div>
          ))}
        </div>

        <div className="reveal mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 text-sm">
          <span className="text-stone-600">See your space transformed —</span>
          <div className="flex gap-3">
            <a
              href="mailto:thestoneremedy@gmail.com"
              className="inline-flex items-center gap-2 px-5 py-3 bg-stone-900 text-white"
            >
              <Mail className="w-4 h-4" /> Email Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
